var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5624 0.5H2.18742C0.981217 0.5 4.47035e-07 1.48122 4.47035e-07 2.68742V8.31242C4.47035e-07 9.51886 0.981217 10.5001 2.18742 10.5001H11.5624C12.7689 10.5001 13.7501 9.51886 13.7501 8.31242V2.68742C13.7501 1.48122 12.7689 0.5 11.5624 0.5Z",
    fill: "#2029DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5624 12.9999H2.18742C0.981216 12.9999 0 13.9811 0 15.1876V28.3126C0 29.5188 0.981216 30.5 2.18742 30.5H11.5624C12.7689 30.5 13.7501 29.5188 13.7501 28.3126V15.1876C13.7501 13.9811 12.7689 12.9999 11.5624 12.9999Z",
    fill: "#2029DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8126 20.4999H18.4376C17.2311 20.4999 16.2499 21.4811 16.2499 22.6876V28.3126C16.2499 29.5188 17.2311 30.5 18.4376 30.5H27.8126C29.0188 30.5 30 29.5188 30 28.3126V22.6876C30 21.4811 29.0188 20.4999 27.8126 20.4999Z",
    fill: "#2029DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8126 0.5H18.4376C17.2311 0.5 16.2499 1.48122 16.2499 2.68742V15.8124C16.2499 17.0189 17.2311 18.0001 18.4376 18.0001H27.8126C29.0188 18.0001 30 17.0189 30 15.8124V2.68742C30 1.48122 29.0188 0.5 27.8126 0.5Z",
    fill: "#2029DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.34fc8d76375f7649c4c3504c8814bc8f.svg";
export { ForwardRef as ReactComponent };